export default function () {
	return `
	</form>
	`;
}
